import React, { useEffect } from "react";
import { WinterSnowfall } from "./WinterSnowfall";
import { ChristmasLights } from "./ChristmasLights";
import { useHolidayTheme } from "@/hooks/useHolidayTheme";
import "@/styles/seasonal.css";

interface ChristmasThemeProviderProps {
  children: React.ReactNode;
}

export const ChristmasThemeProvider: React.FC<ChristmasThemeProviderProps> = ({ children }) => {
  const { isChristmas } = useHolidayTheme();

  useEffect(() => {
    if (isChristmas) {
      document.body.classList.add("christmas-theme");
    } else {
      document.body.classList.remove("christmas-theme");
    }

    return () => {
      document.body.classList.remove("christmas-theme");
    };
  }, [isChristmas]);

  return (
    <>
      {isChristmas && (
        <>
          <WinterSnowfall count={40} />
          <ChristmasLights />
        </>
      )}
      {children}
    </>
  );
};

export default ChristmasThemeProvider;
